import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { BasicPage } from '@app/model/basic-page.model';
import { UserActivityType } from '@app/model/enums/user-activity-type.enum';
import { QuestionDTO } from '@app/model/questionDTO.model';
import { SlideDTO } from '@app/model/slideDTO.model';
import { SlidesApiService } from '@app/services/api/slides-api.service';
import { UserActivityService } from '@app/services/user-activity.service';
import { EntityTypeId, TypographyService, TypographyApiService } from 'library-explorer';
import { combineLatest } from 'rxjs';


@Component({
    selector: 'app-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.scss'],
    standalone: false
})
export class PageComponent implements AfterViewInit {
  @Input() public set page(value: BasicPage) {
    if (!value) {
      this._page = null;
      this.slideBuilderData = null;
      return;
    }

    this._page = value;
    this.init();
  }

  public get page() {
    return this._page;
  }

  public slideBuilderData = null;
  public containerHeight: number = 0;

  public typographyThemes = [];

  private _page: BasicPage;

  constructor(
    private readonly typographyApiService: TypographyApiService,
    private readonly typographyService: TypographyService,
    private readonly element: ElementRef,
    private readonly slideApiService: SlidesApiService,
    private readonly userActivityService: UserActivityService) { }

  ngAfterViewInit(): void {
    this.containerHeight = document.getElementById('full-layout-scroll-section')?.offsetHeight || 0;
  }

  public videoWatched(slide: SlideDTO): void {
    if (!slide) {
      return;
    }

    this.userActivityService.logUserVideoActivity(UserActivityType.USER_WATCHED_VIDEO, slide.id, EntityTypeId.PARAGRAPH, slide.mediaVideo);
  }

  private init() {
    const slide = this._page.slides?.items?.[0];

    if (!slide) {
      return;
    }


    combineLatest([
      this.typographyApiService.getTypographyThemes(),
      this.slideApiService.loadPresignedUrlsForSlideMedia(slide, this.element.nativeElement.offsetWidth)
    ])
      .subscribe(([typographyThemes, data]) => {
        this.slideBuilderData = data;
        this.typographyThemes = typographyThemes?.items || [];
        this.setTypographyTheme(data);
      });
  }

  private setTypographyTheme(slide: SlideDTO | QuestionDTO): void {
    if (!slide) {
      return;
    }
  
    const { themeId, typographyOverrides } = slide;
    const activeTheme = this.typographyThemes?.find(theme => theme.id?.toString() === themeId?.toString()) || this.typographyThemes?.[0];
    this.typographyService.applyTypographyTheme(activeTheme, this.element.nativeElement, typographyOverrides);
  }
}
